import { RcClasses, spacing } from '../../../../foundation';
export var RcMenuItemPrefix = 'RcMenuItem';
export var RcMenuItemRipplePrefix = RcMenuItemPrefix + "TouchRipple";
export var RcMenuItemClasses = RcClasses(['checked', 'unchecked', 'gutters', 'dense', 'selected', 'focusVisible'], RcMenuItemPrefix);
export var RcMenuItemTopAndBottomPaddings = {
    medium: spacing(1),
    large: spacing(2),
};
export var RcMenuItemLeftAndRightPaddings = {
    medium: spacing(4),
    large: spacing(5),
};
export var RcMenuItemRippleClasses = RcClasses(['rippleVisible'], RcMenuItemRipplePrefix);
